import type { QueryOptions } from '@tanstack/react-query';

import { http, internalHttp } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const scheduleAPI = {
  classrooms: ({ ...params }: Record<string, string | number>) =>
    http.get<ListData<ClassroomSchedule>>('/api/info/classrooms/schedule', { params }).then(({ data }) => data),

  teacher: ({ ...params }: Record<string, string | number>) =>
    http.get<ListData<TeacherSchedule>>('/api/info/teacher/schedule', { params }).then(({ data }) => data),

  daily_schedule: ({ ...params }: Record<string, string | number>) =>
    internalHttp
      .get<ListData<DailySchedule>>('/api/info/classroom/daily_schedule', { params })
      .then(({ data }) => data),

  diligent: ({ ...params }: Record<string, string | number>) =>
    internalHttp.get<ListData<ClassDiligent>>('/api/info/class/report/diligent', { params }).then(({ data }) => data),

  attendance_report: ({ ...params }: Record<string, string | number>) =>
    internalHttp
      .get<ListData<AttendanceReport>>('/api/info/class-student/attendance-report', { params })
      .then(({ data }) => data),
};

export const scheduleQuery = {
  classrooms: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetScheduleClassRooms', params] as const,
      queryFn: () => scheduleAPI.classrooms(getQueryParameters(params)),
    }) as const satisfies QueryOptions,

  teacher: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetScheduleTeacher', params] as const,
      queryFn: () => scheduleAPI.teacher(getQueryParameters(params)),
    }) as const satisfies QueryOptions,

  daily_schedule: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetClassroomDailySchedule', params] as const,
      queryFn: () => scheduleAPI.daily_schedule(getQueryParameters(params)),
    }) as const satisfies QueryOptions,

  get_diligent: (params: QueryParams<Partial<SearchFormData>>) => ({
    queryKey: ['GetDiligent', params] as const,
    queryFn: () => scheduleAPI.diligent(getQueryParameters(params)),
  }),

  get_attendance_report: (params: QueryParams<Partial<SearchFormData>>) => ({
    queryKey: ['GetAttendanceReport', params] as const,
    queryFn: () => scheduleAPI.attendance_report(getQueryParameters(params)),
  }),
};
